"use client"

import { memo, useState } from "react"
import { useAuth } from "@/contexts/AuthContext"
import PrimaryNavStrip from "@/components/nav/PrimaryNavStrip"
import CategoryMegaMenu from "@/components/nav/CategoryMegaMenu"

const SpecialCategoriesStrip = () => {
	const { specialCategories, navPreview } = useAuth()
	const [hoveredCategoryId, setHoveredCategoryId] = useState(null)

	const clearCategoryHover = () => setHoveredCategoryId(null)

	if (!specialCategories?.length) return null

	return (
		<div
			className="relative site-bar site-bar--primary-nav site-bar--special-nav"
			onMouseLeave={clearCategoryHover}
		>
			<div className="site-container site-bar__inner">
				<PrimaryNavStrip
					categories={specialCategories}
					showQuickLinks={false}
					ariaLabel="Special categories"
					activeCategoryId={hoveredCategoryId}
					onCategoryHover={setHoveredCategoryId}
				/>
			</div>

			{/* Desktop only — same 4-news mega menu as main category strip */}
			<div className="hidden lg:block">
				<CategoryMegaMenu
					categories={specialCategories}
					previewByCategoryId={navPreview}
					activeCategoryId={hoveredCategoryId}
					onHoverCategory={setHoveredCategoryId}
					onLeave={clearCategoryHover}
				/>
			</div>
		</div>
	)
}

export default memo(SpecialCategoriesStrip)
